import { createState, State, useState } from '@hookstate/core';
import { getDevice } from '@utils/getDevice';

export interface INavigationState {
  /** Height of blue bar */
  offsetTop: number;
  navigationTab: NavigationTabs;
  /** Width of sidebar when closed
   *
   *  Todo: Cleanup places this is used to avoid bugs.
   */
  minLeft: number;
  /** Width of sidebar when open */
  maxLeft: number;
  sidebarOpen: boolean;
}

type NavigationTabs = 'root' | 'accounts';

export const initialNavigationState: INavigationState = {
  offsetTop: 6,
  navigationTab: 'root',
  minLeft: 55,
  maxLeft: 211,
  sidebarOpen: false,
};

// Spread to avoid mutating
const navigationState = createState<INavigationState>(() => {
  if (getDevice().includes('mobile')) {
    return { ...initialNavigationState, offsetTop: 0 };
  }
  return { ...initialNavigationState };
});

const wrapState = (state: State<INavigationState>) => ({
  ...state,
  toggleNavigation: () => {
    state.set(oldState => ({
      sidebarOpen: !oldState.sidebarOpen,
      navigationTab: oldState.sidebarOpen ? 'root' : oldState.navigationTab,
      offsetTop: oldState.offsetTop,
      minLeft: oldState.minLeft,
      maxLeft: oldState.maxLeft,
    }));
  },
  closeNavigation: () => {
    state.set(oldState => ({
      sidebarOpen: false,
      navigationTab: 'root',
      offsetTop: oldState.offsetTop,
      minLeft: oldState.minLeft,
      maxLeft: oldState.maxLeft,
    }));
  },
  openNavigation: () => {
    state.set(oldState => ({
      sidebarOpen: true,
      navigationTab: oldState.navigationTab,
      offsetTop: oldState.offsetTop,
      minLeft: oldState.minLeft,
      maxLeft: oldState.maxLeft,
    }));
  },
});

const useNavigationState = () => wrapState(useState(navigationState));

export { navigationState, useNavigationState };
